import CustomerSupport from '../../src/legacy/CustomerSupport.tsx';
export default CustomerSupport;
